const filters = {
  // 将货币转化为千分位
  filterMoney: function (value) {
    const options = {
      style: 'currency', // currency货币格式
      currency: 'CNY'
    }
    return value.toLocaleString('zh-CN', options).replace(/[^\d\,\.]/g, '')
  }
}

export default filters
